import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandMark from './BrandMark';

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const linkClass = (path) => {
    const active =
      path === '/blog'
        ? pathname.startsWith('/blog')
        : path === '/product'
          ? pathname === '/product'
          : pathname === path;
    return `site-nav__link${active ? ' is-active' : ''}`;
  };

  const close = () => setOpen(false);

  return (
    <header className="site-nav">
      <div className="site-nav__inner">
        <BrandMark onClick={close} className="site-nav__brand-mark" />

        <button
          type="button"
          className={`site-nav__toggle${open ? ' is-open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
        </button>

        <nav className={`site-nav__links${open ? ' is-open' : ''}`} aria-label="Primary">
          <Link to="/product#journey" className={linkClass('/product')} onClick={close}>
            How it works
          </Link>
          <Link to="/pricing" className={linkClass('/pricing')} onClick={close}>
            Pricing
          </Link>
          <Link to="/blog" className={linkClass('/blog')} onClick={close}>
            Blog
          </Link>
          <Link to="/about" className={linkClass('/about')} onClick={close}>
            About
          </Link>
          <Link to="/login" className={linkClass('/login')} onClick={close}>
            Log in
          </Link>
          <Link to="/signup" className="site-nav__cta" onClick={close}>
            Start free
          </Link>
        </nav>
      </div>
    </header>
  );
}
